module.exports = __webpack_public_path__ + "img/sort-icon-2.057ead06.png";